<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card">
            <p-table #dt [value]="perfiles" [columns]="cols" dataKey="id"
                     selectionMode="multiple" [(selection)]="perfilesSeleccionados"
                     [rowHover]="true" [rows]="10" [paginator]="true"
                     [scrollable]="false" [responsive]='true'
                     [filterDelay]="0" [globalFilterFields]="['nombre','descripcion']"
                     sortMode="multiple" [multiSortMeta]="multiSortMeta"
                     [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                     styleClass="p-datatable-striped">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-start table-header">
                            <button pButton type="button" 
                                    label="{{appConfig.ux.actions.create}}" 
                                    icon="pi pi-plus"
                                    (click)="nuevoPerfil();"
                                    [disabled]="!puedeEjecutar('crear')">
                            </button>
                            <button pButton pRipple type="button"
                                    pTooltip="Borrar seleccionadas" tooltipPosition="bottom"
                                    icon="pi pi-trash" class="p-button-help p-ml-1"
                                    (click)="confirmarBorrarSeleccionados();" 
                                    [disabled]="!puedeEjecutar('borrado') 
                                    || !(perfilesSeleccionados && perfilesSeleccionados.length)">
                            </button>
                        </div>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                   placeholder="Buscar.."/>
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width: 3rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [hidden]="!col.visible">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </div>
                    </th>
                    <th style="width: 12rem"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns"r>
                    <tr>
                        <td style="width: 3rem">
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                    </td>
                    <td *ngFor="let col of columns" [hidden]="!col.visible">
                        {{rowData[col.field]}}
                    </td>
                    <td style="width: 12rem">
                        <button pButton type="button" 
                                pTooltip="{{appConfig.ux.actions.config}}" tooltipPosition="bottom" 
                                icon="pi pi-cog" class="p-button-rounded"
                                (click)="pl.resetFilter(); editarPerfilTareas(rowData)"
                                [disabled]="!puedeEjecutar('escritura')">
                        </button>
                        <button pButton type="button" 
                                pTooltip="{{appConfig.ux.actions.edit}}" tooltipPosition="bottom" 
                                icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-plain"
                                (click)="editarPerfil(rowData);"
                                [disabled]="!puedeEjecutar('escritura')">
                        </button>
                        <button *ngIf="rowData['nombre'] 
                                && (!rowData['nombre'].toLowerCase().includes('admin') 
                                && !rowData['nombre'].toLowerCase().includes('usuario'))"
                                pButton type="button" 
                                pTooltip="{{appConfig.ux.actions.delete}}" tooltipPosition="bottom" 
                                icon="pi pi-trash" class="p-button-rounded p-button-text p-button-secondary"
                                (click)="confirmarBorrarPerfil(rowData);"
                                [disabled]="!puedeEjecutar('borrado')">
                        </button>
                    </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8">{{appConfig.ux.emptyMsg}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <button pButton type="button" 
                            pTooltip="{{appConfig.ux.actions.refresh}}" tooltipPosition="bottom" 
                            icon="pi pi-refresh" class="p-button-rounded p-button-text"
                            (click)="dt.reset();">
                    </button>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<!-- Diálogos de creación/edición de perfil -->
<p-dialog [header]="(perfil && perfil.id) ? 'Editar Perfil' : 'Nuevo Perfil'" 
          [(visible)]="mostrarEditor && perfil" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}"
          (onHide)="mostrarEditor=false;">
    <form #perfilEditorForm="ngForm"
          (ngSubmit)="guardarPerfil();"
          [ngClass]="{'disabledForm': false}"><!--perfilEditorForm.reset();-->
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field col-12">
                <h2 class="p-text-uppercase">{{perfil.name}}</h2>
            </div>
            <div class="p-field col-12">
                <label for="nombre">Nombre</label>
                <input #nombre="ngModel" id="nombre" name="nombre" type="text" 
                       [(ngModel)]="perfil.name" 
                       [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                       [disabled]="perfil.name 
                       && (perfil.name.toLowerCase().includes('admin')
                       || perfil.name.toLowerCase().includes('usuario'))"
                       required pInputText>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeTextPattern']" 
                           *ngIf="perfilEditorForm.controls['nombre']
                           && !perfilEditorForm.controls['nombre'].valid 
                           && (perfilEditorForm.controls['nombre'].dirty 
                           || perfilEditorForm.controls['nombre'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12">
                <label for="descripcion">Descripción</label>
                <textarea #descripcion="ngModel" id="descripcion" name="descripcion" type="text"
                          [(ngModel)]="perfil.description" 
                          [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                          [rows]="5"
                          pInputTextarea></textarea>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                           *ngIf="perfilEditorForm.controls['descripcion'] 
                           && !perfilEditorForm.controls['descripcion'].valid 
                           && (perfilEditorForm.controls['descripcion'].dirty 
                           || perfilEditorForm.controls['descripcion'].touched)">
                </p-message>
            </div>
        </div>
        <p-footer>
            <div class="p-d-flex p-flex-lg-row p-flex-column p-jc-end">
                <button pButton type="button" 
                        label="{{appConfig.ux.actions.cancel}}"
                        icon="pi pi-times" class="p-button-secondary"
                        (click)="mostrarEditor=false;">
                </button>
                <button pButton type="submit" 
                        label="{{appConfig.ux.actions.save}}"
                        icon="pi pi-check" class="p-ml-lg-1"
                        [disabled]="(!perfilEditorForm.valid)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!--Diálogo de asignación de tareas-->
<p-dialog header=" " 
          [(visible)]="mostrarEditorPerfilTareas && perfil"
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}"
          (onHide)="mostrarEditorPerfilTareas=false;">
    <form #tareasPerfilEditorForm="ngForm"
          (ngSubmit)="confirmarGuardarPerfilTareas(); tareasPerfilEditorForm.reset();"
          [ngClass]="{'disabledForm': false}">
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field col-12 p-text-center">
                <h2 class="p-text-uppercase">Agregar/Quitar tareas del perfil {{perfil.name}}</h2>
                <label class="p-text-italic p-text-bold">(Para cambiar los permisos de una tarea asignada, por favor haga click sobre ella)</label>
            </div>
            <div class="p-field col-12 p-md-9">
                <p-pickList #pl [source]="tareasNoAsignadas" [target]="tareasAsignadas"
                            sourceHeader="No asignados" targetHeader="Asignados"
                            filterBy="nombre"
                            [responsive]="true" [dragdrop]="true"
                            [sourceStyle]="{'height':'300px'}" [targetStyle]="{'height':'300px'}"
                            (onTargetSelect)="cargarTareaPermisos($event);"
                            (onMoveToTarget)="agregarItemsTarea($event);"
                            (onSourceSelect)="limpiarPermisos($event);"
                            (onMoveToSource)="agregarItemsTarea($event);">
                    <ng-template let-tarea pTemplate="item">
                        <div>{{tarea.name}}</div>
                    </ng-template>
                </p-pickList>
            </div>
            <div class="p-field col-12 p-md-3 align-self-center">
                <p-listbox [options]="permisos" optionLabel="name"
                           [(ngModel)]="permisosSeleccionados" 
                           [ngModelOptions]="{standalone: true}"
                           [multiple]="true" [checkbox]="true" 
                           [metaKeySelection]="false"
                           (onClick)="asignarTareaPermisos($event)"
                           (onDblClick)="asignarTareaPermisos($event)"
                           (onChange)="asignarTareaPermisos($event)"
                           emptyMessage="Aún sin definir permisos..."
                           [disabled]="!tarea.id"
                           [listStyle]="{'max-height':'250px'}">
                    <ng-template pTemplate="header">
                        <strong>Permisos {{tarea.id ? 'de': ''}}  {{tarea.id ? tarea.name: ''}}</strong>
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                        <div class="item-item">
                            <div>{{item.name}}</div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="footer">
                    </ng-template>
                </p-listbox>
            </div>
        </div>
        <p-footer>
            <div class="p-d-flex p-flex-lg-row p-flex-column p-jc-end">
                <button pButton type="button" 
                        label="{{appConfig.ux.actions.cancel}}"
                        icon="pi pi-times" class="p-button-secondary"
                        (click)="mostrarEditorPerfilTareas=false;">
                </button>
                <button pButton type="submit" 
                        label="{{appConfig.ux.actions.save}}"
                        icon="pi pi-check" class="p-ml-lg-1"
                        [disabled]="(!tareasPerfilEditorForm.valid)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd header="Confirmación" icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton type="button" 
                label="No"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton type="button" 
                label="Sí"
                icon="pi pi-check" class="p-ml-2"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>